import { WorkExperience as WorkExperienceRecord } from '../../../../../store/workspace/types';
import { EditIcon, TrashIcon } from '../../../../../assets/icons/common';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal';
import InfoCard, { InfoRow } from '../../components/InfoCard';
import { useRecordDialogs } from '../../hooks/useRecordDialogs';
import { useProfileUpdate } from '../../hooks/useProfileUpdate';
import WorkExperienceForm from './WorkExperienceForm';
import AddButton from '../../components/AddButton';
import styles from './style.module.scss';

const byStartDate = (a: WorkExperienceRecord, b: WorkExperienceRecord) =>
    new Date(a.from).getTime() - new Date(b.from).getTime();

/** Lists the applicant's jobs, oldest first, and hosts the add / edit / delete dialogs. */
function WorkExperience() {
    const { profile, isSaving, saveProfile } = useProfileUpdate();
    const dialogs = useRecordDialogs<WorkExperienceRecord>();

    const records = profile?.workExperience;
    const sorted = [...(records || [])].sort(byStartDate);

    const deleteRecord = async () => {
        if (!records || !dialogs.deleting) return;
        const saved = await saveProfile({
            workExperience: records.filter(i => i.id !== dialogs.deleting?.id),
        });

        if (saved) dialogs.cancelDelete();
    };

    return (
        <div className={styles.wrapper}>
            {records?.length === 0 && <span>I don't have work experience.</span>}

            {sorted.map((item, index) => <InfoCard
                key={item.id}
                title={`Job ${index + 1}`}
                actions={<>
                    <EditIcon onClick={() => dialogs.openEditForm(item)} />
                    <TrashIcon onClick={() => dialogs.askToDelete(item)} />
                </>}
            >
                <InfoRow label='Job title' value={item.jobTitle} />
                <InfoRow label='Company' value={item.company} />
                <InfoRow label='Location' value={item.location} />
                <InfoRow label='Role description' value={item.roleDescription} stackOnMobile />
                <InfoRow label='Date' value={`${item.from} - ${item.to}`} />
            </InfoCard>)}

            <AddButton text='+ Add work experience' onClick={dialogs.openAddForm} />

            {dialogs.isFormOpen && <WorkExperienceForm
                experience={dialogs.editing}
                onClose={dialogs.closeForm}
            />}

            {dialogs.deleting && <ConfirmDeleteModal
                loading={isSaving}
                title='Delete work experience'
                onConfirm={deleteRecord}
                onCancel={dialogs.cancelDelete}
                question={`Are you sure you want to delete "${dialogs.deleting.jobTitle}" ?`}
            />}
        </div>
    );
};

export default WorkExperience;
